import validator from 'validator';

import { requiredFieldValidator } from './requiredFieldVaildator';

interface InputLengthValidator {
  (input: string, lengthMinLimit: number): boolean;
}

export const inputLengthValidator: InputLengthValidator = (input, lengthMinLimit) => {
  const isRequired = requiredFieldValidator(input);
  if (!isRequired) {
    return false;
  }
  const isValidLengthInput = validator.isLength(input.trim(), { min: lengthMinLimit });
  if (!isValidLengthInput) {
    return false;
  }
  return true;
};
